const apiUrl = "https://hackerfolioevent.herokuapp.com/";
export {

    apiUrl
}